import * as actionTypes from './actionTypes';
export const setNotificationRef = (notificationRef) => {
    return {
        type: actionTypes.SET_NOTIFY_REF,
        refNotify: notificationRef
    }
}

